// Decision 18/10 (Mohammed): one customer's line on a job is a "customer quote". Same customer + same product type +
// SAME branch is blocked; through another branch, or with another product type, it is a warning. For an existing
// customer quote the user makes a new version of it, through the CRM's normal revision (same quote number, next
// version); "New Customer Quote" adds a new line with its own quote number. No dependencies, so the Quotations tab can
// use it too.

/** The customer quotes a check names, with what the screen shows and the route that makes a new version. */
export function existingQuotes(check) {
  return ((check && check.existing) || []).map(e => ({
    oppId: e.oppId,
    sQuoteNo: e.sQuoteNo || null,
    productType: e.productType || '',
    branch: e.branch || '',
    oppStatus: e.oppStatus || '',
    match: e.match || null,
    reason: e.reason || null,
    canCreateVersion: canCreateVersion(e),
    route: newVersionRoute(e)
  }))
}

/** The server says whether the quote can be revised (be3 5dbdf83: false when the enquiry has no active quote yet). */
export function canCreateVersion(e) {
  if (!e || !e.sQuoteNo) return false
  return e.canCreateVersion !== false
}

/**
 * Where "Create New Version" goes: the enquiry's Quotations tab, which opens the normal revision of that quote's latest
 * version (Quotation-Table openRequestedVersion). An enquiry with no quote yet has nothing to revise: its page opens.
 */
export function newVersionRoute(e) {
  if (!e || !e.oppId) return null
  if (!canCreateVersion(e)) return { path: '/enquiries/' + e.oppId + '/detail' }
  return { path: '/enquiries/' + e.oppId + '/quotations', query: { newVersionOf: e.sQuoteNo } }
}

// Why each existing quote is named (checkCustomer reason)
export const REASON_TEXT = {
  SAME_BRANCH: 'the same product type through the same branch',
  OTHER_BRANCH: 'the same product type through another branch',
  OTHER_PRODUCT_TYPE: 'another product type'
}

/**
 * "WATES already has a Doorsets quotation on this enquiry through MBP Doorsets (Q42009): the same product type through another
 * branch." for each existing quotation; without a reason the sentence ends at the quote number.
 */
export function existingSentence(custName, e) {
  const who = custName || 'This customer'
  const what = e.productType ? 'a ' + e.productType + ' quotation' : 'a quotation'
  const through = e.branch ? ' through ' + e.branch : ''
  const no = e.sQuoteNo ? ' (' + e.sQuoteNo + ')' : ' (no quote number yet)'
  const why = REASON_TEXT[e.reason] ? ': ' + REASON_TEXT[e.reason] : ''
  return who + ' already has ' + what + ' on this enquiry' + through + no + why + '.'
}

/** The latest version of a quote number among the Quotations tab's rows, or null. */
export function latestVersionOf(quotations, sQuoteNo) {
  const rows = (quotations || []).filter(q => q && q.sQuoteNo === sQuoteNo)
  if (!rows.length) return null
  return rows.slice().sort((a, b) =>
    (Number(b.versionNo) || 0) - (Number(a.versionNo) || 0) || (Number(b.quoteVerId) || 0) - (Number(a.quoteVerId) || 0))[0]
}
